import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { Expression } from "abreact/expression/Expression";
import { ExpressionStructureNode } from "abreact/expression/ui/editor/readonly/ExpressionStructureNode";
import { ExpExpressionNodeNodeTypeEnum } from "abweb/generated/abwebinternal/api/dto/ExpExpressionNode";
export class ExpressionStructure {
  constructor(expressionDomainModel) {
    _defineProperty(this, "_rootNode", void 0);
    _defineProperty(this, "_expressionDomainModel", void 0);
    _defineProperty(this, "_isSingleFireAction", false);
    this._expressionDomainModel = expressionDomainModel;
  }
  get expressionDomainModel() {
    return this._expressionDomainModel;
  }
  initFromExpressionDefinition(expressionDefinition) {
    if (expressionDefinition) {
      if (expressionDefinition.executionFlags && expressionDefinition.executionFlags.indexOf(Expression.Domain.Constants.SINGLE_FIRE_ACTION_LIST_EXECUTION_FLAG) > -1) {
        this._isSingleFireAction = true;
      }
      this._rootNode = ExpressionStructureNode.createRootNode(this.expressionDomainModel, expressionDefinition);
      // non-boolean definitions sometimes are in a state where there is no operator selected yet. Just being defensive with
      // the test for operator id
      if (expressionDefinition.rootNode) {
        if (expressionDefinition.rootNode.nodeType === ExpExpressionNodeNodeTypeEnum.OPERATOR || expressionDefinition.rootNode.nodeType === ExpExpressionNodeNodeTypeEnum.ACTION_LIST) {
          this.processNode(expressionDefinition.rootNode, this._rootNode);
        }
      }
    }
  }
  initFromExpressionNode(expExpressionNode, leafNodeOperatorID) {
    this._rootNode = this._rootNode = ExpressionStructureNode.createRootNode(this.expressionDomainModel, expExpressionNode);
    this.processNode(expExpressionNode, this._rootNode, leafNodeOperatorID);
  }
  get rootNode() {
    return this._rootNode;
  }
  processNode(expExpressionNode, parent, leafNodeOperatorID) {
    let currentExpressionTreeNode;
    let expressionStructureNodeType = this.calculateExpressionStructureNodeType(expExpressionNode);
    if (expressionStructureNodeType === "CONNECTOR" || expressionStructureNodeType === "ACTION_LIST") {
      currentExpressionTreeNode = new ExpressionStructureNode(expressionStructureNodeType, this.expressionDomainModel, expExpressionNode, parent, undefined, this._isSingleFireAction);

      // the children of a CONNECTOR node are operators that represent conditions
      if (expExpressionNode.operandValues != null && expExpressionNode.operandValues.length > 0) {
        expExpressionNode.operandValues.forEach(expConditionNode => {
          this.processNode(expConditionNode, currentExpressionTreeNode);
        });
      }
    } else {
      currentExpressionTreeNode = new ExpressionStructureNode(expressionStructureNodeType, this.expressionDomainModel, expExpressionNode, parent, leafNodeOperatorID, this._isSingleFireAction);
      if (expExpressionNode.operandValues != null && expExpressionNode.operandValues.length > 0) {
        expExpressionNode.operandValues.forEach(operandNode => {
          let operandStructureType = this.calculateExpressionStructureNodeType(operandNode);
          if (operandStructureType === "CONNECTOR") {
            this.processNode(operandNode, currentExpressionTreeNode);
          }
        });
      }
    }
    if (parent != null) {
      parent.children.push(currentExpressionTreeNode);
    }
    return currentExpressionTreeNode;
  }
  calculateExpressionStructureNodeType(expNode) {
    let nodeType;
    switch (expNode.nodeType) {
      case ExpExpressionNodeNodeTypeEnum.LITERAL:
      case ExpExpressionNodeNodeTypeEnum.REFERENCE:
        nodeType = "LEAF";
        break;
      case ExpExpressionNodeNodeTypeEnum.ACTION_LIST:
        nodeType = "ACTION_LIST";
        break;
      case ExpExpressionNodeNodeTypeEnum.OPERATOR:
        if (expNode.operatorID === Expression.Domain.Constants.AND_OPERATOR_ID || expNode.operatorID === Expression.Domain.Constants.OR_OPERATOR_ID) {
          nodeType = "CONNECTOR";
        } else {
          nodeType = "OPERATOR";
        }
        break;
      default:
        throw new Error(`Unsupported node type: ${expNode.nodeType}`);
    }
    return nodeType;
  }
}
//# sourceMappingURL=ExpressionStructure.js.map
